<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import NervenetFrame from './NervenetFrame.vue';

const { accountId } = useAccount();

const supervisorUrl = computed(
  () =>
    `${window.chatwootConfig.nervenetBaseUrl}/accounts/${accountId.value}/agent/supervisor`
);
</script>

<template>
  <NervenetFrame :src="supervisorUrl" />
</template>
